export default `
  mutation createOrganisation($name: String!, $id: String) {
    createOrganisation(name: $name, id: $id) {
        id
        name
        userId
        adminAllowedAiVersions
        allowedAiVersions
        defaultAiVersion
        user {
          id
          firstname
          lastname
        }
        projects {
          id
          name
        }
        createdAt
        updatedAt
      }
  }
`
